'use strict';

export default angular
  .module('maestro.filters.F2C', [])

  .filter('F2C', function() {
    return function(value) {
      return ((Number(value) - 32) / 1.8).toFixed(1);
    };
  })

  .name;
